// extracted by mini-css-extract-plugin
module.exports = {"StatusBase":"StatusBase--3sFs-","Initial":"Initial--5co8u","Analysing":"Analysing--2yuZ-","Completed":"Completed--nNQl-"};